<template>
    <div class="bg businessIntroduce">
        <div class="up-wrap" v-if="isShowUp">
            <div class="w-1200 flex-between">
            <div class="blk" @click="scrollTo(1)">
                <img src="../assets/images/businessIntroduce/up_01.png" alt="">
                <p>档案机器人</p>
            </div>
            <div class="blk" @click="scrollTo(2)">
                <img src="../assets/images/businessIntroduce/up_02.png" alt="">
                <p>文档大数据平台</p>
            </div>
            <div class="blk" @click="scrollTo(5)">
                <img src="../assets/images/businessIntroduce/up_05.png" alt="">
                <p>智慧档案系统</p>
            </div>
            <div class="blk" @click="scrollTo(4)">
                <img src="../assets/images/businessIntroduce/up_04.png" alt="">
                <p>数字声像系统</p>
            </div>
            <div class="blk" @click="scrollTo(3)">
                <img src="../assets/images/businessIntroduce/up_03.png" alt="">
                <p>智慧党建系统</p>
            </div>
            <div class="blk" @click="scrollTo(6)">
                <img src="../assets/images/businessIntroduce/up_06.png" alt="">
                <p>智慧执法系统</p>
            </div>
            </div>
        </div>
        <headerCom></headerCom> 
        <div class="intr">
            <div class="w-body title-wrap" style="padding:60px 0 32px">
                <div class="name">业务介绍</div>
                <div class="interval-line"></div>
                <div class="e-name">BUSINESS INTRODUCTION</div>
            </div>
            <div class="w-1200">
            <p class="line1">以“卓越、智汇、合力、创新”为企业核心理念，以“一流产品、高效服务”</p>
            <p class="line2">为发展使命，以“用户满意”为根本出发点。</p>
            <p class="line3">致力于深度开发政府、大中型企事业单位大数据应用支撑！</p>
            </div>
        </div>
        <div class="info w-1200">
            <img src="../assets/images/businessIntroduce/bg_left.png" alt="">
            <p>杭州卓智力创信息技术有限公司2017年6月成立,依托团队多年来在能源、公安、交通、行政执法、自然资源及政府部门等不同应用的技术实践和经验积累，着眼于国内市场需求，以“用户满意”为根本出发点，以“卓越、智汇、合力、创新”为企业思想，以开拓性发展思路为用户提供最优秀、适时的技术咨询、人工智能技术开发和大数据应用平台支撑服务。</p>
        </div>
        <div class="business w-1200">
            <div class="name">业务介绍</div>
            <div class="wrap">
                <div class="blk" v-for="(item,i) in businessList" :key="i+'0'">
                    <!-- <img src="../assets/images/businessIntroduce/business_01.png" alt=""> -->
                    <div>
                        <p class="title-name">
                            {{item.busName}}
                        </p>
                        <p class="mess">
                            {{item.busSynopsis}}
                        </p>
                        <img :src="httpUrl+'/disk/'+item.busPath" alt="">
                    </div>
                    <div class="flex-center h">
                        <img :src="httpUrl+'/disk/'+i" alt="" v-for="(i,index) in item.filesPaths.split(',')" :key="'9'+index">

                        <!-- <img src="../assets/images/businessIntroduce/business_01_01.png" alt="">
                        <img src="../assets/images/businessIntroduce/business_01_02.png" alt="">
                        <img src="../assets/images/businessIntroduce/business_01_03.png" alt="">
                        <img src="../assets/images/businessIntroduce/business_01_04.png" alt=""> -->
                    </div>
                </div>
                <!-- <div class="blk">
                    <img src="../assets/images/businessIntroduce/business_02.png" alt="">
                    <div class="flex-center h">
                        <img src="../assets/images/businessIntroduce/business_02_01.png" alt="">
                        <img src="../assets/images/businessIntroduce/business_02_02.png" alt="">
                        <img src="../assets/images/businessIntroduce/business_02_03.png" alt="">
                        <img src="../assets/images/businessIntroduce/business_02_04.png" alt="">
                    </div>
                </div>
                <div class="blk">
                    <img src="../assets/images/businessIntroduce/business_03.png" alt="">
                    <div class="flex-center h">
                        <img src="../assets/images/businessIntroduce/business_03_01.png" alt="">
                        <img src="../assets/images/businessIntroduce/business_03_02.png" alt="">
                        <img src="../assets/images/businessIntroduce/business_03_03.png" alt="">
                        <img src="../assets/images/businessIntroduce/business_03_04.png" alt="">
                    </div>
                </div>
                <div class="blk">
                    <img src="../assets/images/businessIntroduce/business_04.png" alt="">
                    <div class="flex-center h">
                        <img src="../assets/images/businessIntroduce/business_04_01.png" alt="">
                        <img src="../assets/images/businessIntroduce/business_04_02.png" alt="">
                        <img src="../assets/images/businessIntroduce/business_04_03.png" alt="">
                        <img src="../assets/images/businessIntroduce/business_04_04.png" alt="">
                    </div>
                </div>
                <div class="blk">
                    <img src="../assets/images/businessIntroduce/business_05.jpg" alt="">
                    <div class="flex-center h">
                        <img src="../assets/images/businessIntroduce/business_05_01.png" alt="">
                        <img src="../assets/images/businessIntroduce/business_05_02.png" alt="">
                        <img src="../assets/images/businessIntroduce/business_05_03.png" alt="">
                        <img src="../assets/images/businessIntroduce/business_05_04.png" alt="">
                    </div>
                </div>
                <div class="blk">
                    <img src="../assets/images/businessIntroduce/business_06.png" alt="">
                    <div class="flex-center h">
                        <img src="../assets/images/businessIntroduce/business_06_01.png" alt="">
                        <img src="../assets/images/businessIntroduce/business_06_02.png" alt="">
                        <img src="../assets/images/businessIntroduce/business_06_03.png" alt="">
                        <img src="../assets/images/businessIntroduce/business_06_04.png" alt="">
                    </div>
                </div> -->
            </div>
        </div>
        <!--  -->
         <div class="part1" ref="p1">
            <div class="part-title"><div class="w1200"><p>档案机器人</p></div></div>
            <div class="bg-1">
                <div class="flex-start w-1200">
                    <img src="../assets/images/businessIntroduce/part_01.png" alt="">
                    <div class="text" style="margin-top:85px;">
                        <p>档案机器人 提供7*24小时在线服务</p>
                        <p>人工智能时代，机器人技术运用使档案智慧管理成为现实</p>
                        <p>为档案业务工作连续保驾护航</p>
                    </div>
                </div>
            </div>
            <div class="bg-2 w-1200">
                <div class="blk" v-for="(item,index) in businessInfo.expList0" :key="'1'+index" style="padding:50px 120px;">
                    <div class="name">
                        <img :src="httpUrl+'/disk/'+item.path" alt="" v-if="item.path!=''">
                        {{item.title}}</div>
                    <div class="line"></div>
                    <div class="text">{{item.explainText}}</div>
                </div>
            </div>
        </div>
        
        <div class="part5" ref="p2">
            <div class="part-title"><div class="w1200"><p>文档大数据平台</p></div></div>
            <div class="bg-1">
                <div class="flex-start w-1200">
                    <img src="../assets/images/businessIntroduce/part_05.png" alt="">
                    <div class="text" style="margin-top:48px;">
                        <p>应用现代化信息技术，包括人工智能、大数据、云计算、物联网等对企事业单位</p>
                        <p>大量文档资源进行挖掘、整合、分析、利用、服务</p>
                    </div>
                </div>
            </div>
            <div class="bg-2 w-1200">
                <div class="blk" v-for="(item,index) in businessInfo.expList1" :key="'1'+index">
                    <div class="name">
                        <img :src="httpUrl+'/disk/'+item.path" alt="" v-if="item.path!=''">
                        {{item.title}}</div>
                    <div class="line"></div>
                    <div class="text">{{item.explainText}}</div>
                </div>
            </div>
        </div>
        <div class="part2" ref="p5">
            <div class="part-title"><div class="w1200"><p>智慧档案系统</p></div></div>
            <div class="bg-1">
                <div class="flex-start w-1200">
                    <img src="../assets/images/businessIntroduce/part_02.png" alt="">
                    <div class="text" style="margin-top:85px;">
                        <p>联通互联网、政务网、馆藏内网三网</p>
                        <p>实现档案集“汇交、收整、管理、利用、服务”全过程的</p>
                        <p>数字化、网络化、精细化、智慧化管理。</p>
                    </div>
                </div>
            </div>
            <div class="bg-2 w-1200">
                <div class="blk" v-for="(item,index) in businessInfo.expList3" :key="'1'+index">
                    <div class="name">
                        <img :src="httpUrl+'/disk/'+item.path" alt="" v-if="item.path!=''">
                        {{item.title}}</div>
                    <div class="line"></div>
                    <div class="text">{{item.explainText}}</div>
                </div>
            </div>
        </div>
        <div class="part4" ref="p4">
            <div class="part-title"><div class="w1200"><p>数字声像系统</p></div></div>
            <div class="bg-1">
                <div class="flex-start w-1200">
                    <img src="../assets/images/businessIntroduce/part_04.png" alt="">
                    <div class="text" style="margin-top:129px;">
                        <p>实现企业级的数据声像资源管理</p>
                        <p>对图片、照片、音频、视频等各类文件、数据</p>
                        <p>有序统一管理、智能化利用</p>
                    </div>
                </div>
            </div>
            <div class="bg-2 w-1200">
                <div class="blk" v-for="(item,index) in businessInfo.expList2" :key="'1'+index">
                    <div class="name">
                        <img :src="httpUrl+'/disk/'+item.path" alt="" v-if="item.path!=''">
                        {{item.title}}</div>
                    <div class="line"></div>
                    <div class="text">{{item.explainText}}</div>
                </div>
            </div>
        </div>
        <div class="part3" ref="p3">
            <div class="part-title"><div class="w1200"><p>智慧党建系统</p></div></div>
            <div class="bg-1">
                <div class="flex-start w-1200">
                    <img src="../assets/images/businessIntroduce/part_03.png" alt="">
                    <div class="text" style="margin-top:37px;">
                        <p>以新时代中国特色社会主义思想为指导</p>
                        <p>从严管党，坚持以人民为中心，服务人民为目标</p>
                        <p>架起政府、党员、群众之间沟通的桥梁，第一时间了解群众、服务群众</p>
                    </div>
                </div>
            </div>
            <div class="bg-2 w-1200">
                <div class="blk" v-for="(item,index) in businessInfo.expList4" :key="'1'+index">
                    <div class="name">
                        <img :src="httpUrl+'/disk/'+item.path" alt="" v-if="item.path!=''">
                        {{item.title}}</div>
                    <div class="line"></div>
                    <div class="text">{{item.explainText}}</div>
                </div>
            </div>
        </div>   
        <div class="part6" ref="p6">
            <div class="part-title"><div class="w1200"><p>智慧执法系统</p></div></div>
            <div class="bg-1">
                <div class="flex-start w-1200">
                    <img src="../assets/images/businessIntroduce/part_06.png" alt="">
                    <div class="text" style="margin-top:85px;">
                        <p>实践“智慧+互联网执法”模式 </p>
                        <p>“最多跑一次”理念为引领，推进政府数字化改革</p>
                        <p>强化大数据分析，打造行政执法智慧大平台</p>
                    </div>
                </div>
            </div>
            <div class="bg-2 w-1200">
                <div class="blk" v-for="(item,index) in businessInfo.expList5" :key="'1'+index">
                    <div class="name">
                        <img :src="httpUrl+'/disk/'+item.path" alt="" v-if="item.path!=''">
                        {{item.title}}</div>
                    <div class="line"></div>
                    <div class="text">{{item.explainText}}</div>
                </div>
            </div>
        </div> 
    </div>
</template>
<script>
import {
    busExplainList,
    allList
} from "../api/business.js";
import headerCom from "../components/header";
export default {
    name: "page",
    components: {
        headerCom
    },
    data() {
        return {
            httpUrl: process.env.VUE_APP_URL,
            isShowUp:false,
            fullHeight:"",
            offTop:"",
            part1:[
                {title:'服务大厅',info:'迎宾接待，服务引导、排队取号、在线查询'},
                {title:'服务活动',info:'服务引导、会议签到、活动宣传、重点记录'},
                {title:'服务分析',info:'文档解析、自动摘要、文档检测、知识图谱'},
                {title:'服务生产',info:'文档查阅、在线记录、文档识别、声像播放'}
            ],
            part2:[
                {title:'方案简介',info:'连接政企事业单位内部信息系统，与电子档案系统互通，实现电子档案的“收、管、存、用”。加强三网融合、优化电子档案管理、实现电子档案“网上收、网上归、网上管、网上查、网上用”的全新格局。'},
                {title:'建设目标',info:'以服务生产、强化管理、沉淀档案，做好档案的管理者为目标，按照完整性、真实性、准确性、可靠性为原则搭建电子档案管理平台，提供全面、自主、自动、智能利用。'},
                {title:'关键技术',info:'运用网络传输技术、OCR识别技术、工作流技术、全文搜索技术等，提供互联网、政务网、馆藏内网用户网络化查阅服务。'},
                {title:'方案内容',info:'按照国家档案局数字档案馆（室）建设指南为指导，结合企事业单位自身实际，完成电子档案的在线接收、在线整理、在线归档、在线保管、在线利用，为不同级别的用户提供在线查档服务。'}
            ],
            part3:[
                {title:'方案简介',info:'以“互联网+"信息技术为着力点、创新点，创新网络时代党建管理数字化工作新途径，架设“党委、党支部与基层党员及群众”之间便捷、实时的沟通桥梁，搭建基层党组织、党员和群众资源共享的“新阵地”，全面推进基层党建和服务群众工作顺利开展。'},
                {title:'建设目标',info:'以习近平新时代中国特色社会主义思想为指导，坚持以人民为中心，践行党员服务群众为宗旨，创新推进构建区域统筹、上下联动、共建共享的党建工作新格局。'},
                {title:'关键技术',info:'运用云计算、大数据、物联网、视频分析技术等，建设智慧党建平台的“技术底座”，不断拓展智慧党建应用，促进地区经济繁荣发展。'},
                {title:'方案内容',info:'以信息化提升党建智能、智慧化管理，我们按照党的章程、党员干部管理条例为准则，深化政府管党，党员为群众服务，推进党建工作圈、党员教育圈、党群生活圈、党群服务圈、管理知识圈五圈建设，探索党建管理精细化、精准化、智慧化。'}
            ],
            part4:[
                {title:'方案简介',info:'伴随着数字互联、万物互通，摄像（影）诸多设备产生的照片、音频、视频文件是企事业单位文档资源的重要组成部分，其数据管理和知识管理已是必然趋势。以企事业内网为基础，以声像资源管理为核心，建设企业版的声像数据资源管理平台势在必行。'},
                {title:'建设目标',info:'遵循我国《数码照片归档与管理规范》、《核电电子文件元数据》等技术要求，创建安全网络环境背景下，以电子文件为载体，建立声像文件和数据在线接收、整理、著录、鉴定、管理、传输、发布、利用全过程的文件、档案一体化管理新模式。'},
                {title:'关键技术',info:'运用人脸识别技术、图像处理技术、视频压缩技术、断点续传技术、工作流技术、知识图谱等，提供面向用户网络化、流程化智能服务。'},
                {title:'方案内容',info:'建立企事业单位的“1个平台、2个中心、3级门户”共享平台，重点满足“接收、整理、保管、利用、服务”五大环节关键数据处理和共享。'}
            ],
            part5:[
                {title:'方案简介',info:'整合政企事业单位内部文档数据资源，打造集“数据采集、数据处理、文档管理、文档利用、可视化平台”于一体的大数据平台，以信息化提升数据化管理与服务能力，精准服务。'},
                {title:'建设目标',info:'推动政企事业单位内部文档库、知识库建设为目标，做到“用数据说话、用数据管理、用数据决策、用数据创新”。'},
                {title:'关键技术',info:'运用自然语言处理、OCR识别、数据挖掘、机器学习、知识图谱等技术，满足用户网络化、智能化、智慧化服务。'},
                {title:'方案内容',info:'充分利用单位原有文档资源积累，打通业务系统与文档系统壁垒，实现数据规范化采集、数据标准化处理、电子文档流程化归档、按照程序规范化建库、智能化管理、智慧化服务的全过程、全周期、全方位管理。'}
            ],
            part6:[
                {title:'方案简介',info:'城市管理是国家长治久安的一项重要工作。为推进执法改革，完善行政执法管理体系，加强执法信息化、办案协同化、数据智慧化管理，推进行政执法数字化转型升级，建设大执法、大协同、大数据管理。'},
                {title:'建设目标',info:'坚持以地区性安全网络为依托，以信息技术为手段，实现执法数字化、执法精细化、执法透明化、执法智能化、指挥调度扁平化，打造行政综合执法“智慧大脑”为目标，推进行政执法智慧指挥、智慧决策。'},
                {title:'关键技术',info:'运用人工智能技术、大数据分析技术、全文搜索技术、分布式存储技术、数据加密技术、负载均衡技术等建立城市执法管理8大数据库，为智慧执法做好强有力支撑。'},
                {title:'方案内容',info:'围绕“一网集成、一网执法、一网指挥、一网智办、一网监管、一网分析”的省、市、县(区)三级共享、上下联动为主线，将行政执法业务管理精细化，做到事前有预防、事中有监督、事后可评价、群众可反馈的闭环式管理。建立执法智慧大系统（5平台1中心建设），与省级执法平台、省综监督平台、基层治理平台、机关事务协同平台等互联，提升工作效能。'}
            ],
            businessList:[],
            businessInfo:[],
        };
    },
    mounted() {
        document.addEventListener("scroll", this.handleScroll);
    },
    methods: {
        scrollTo(val){
            if(val==1){
               this.offTop=this.$refs.p1.offsetTop-164
            }
            if(val==2){
               this.offTop=this.$refs.p2.offsetTop-164
            }
            if(val==3){
               this.offTop=this.$refs.p3.offsetTop-164
            }
            if(val==4){
               this.offTop=this.$refs.p4.offsetTop-164
            }
            if(val==5){
               this.offTop=this.$refs.p5.offsetTop-164
            }
            if(val==6){
               this.offTop=this.$refs.p6.offsetTop-164
            }
            window.scrollTo(0, this.offTop);
        },
        handleScroll: function () {
            clearTimeout(this.timer2);
            let _this = this;
            this.timer2 = setTimeout(() => {
                let scrollTop = document.documentElement.scrollTop;
                if (scrollTop > this.fullHeight) {
                    this.isShowUp = true;
                } else {
                    this.isShowUp = false;
                }
            }, 100);
        },
        //-------
        busExplainListFun() {
            busExplainList().then((res) => {
                if (res.code == 200) {
                    this.businessList=res.data;
                }
            });
        },
        allListFun() {
            allList().then((res) => {
                if (res.code == 200) {
                    this.businessInfo=res.data;
                }
            });
        },
    },
    created(){
        window.fullHeight = document.documentElement.clientHeight;
        this.fullHeight= window.fullHeight;
        this.busExplainListFun();
        this.allListFun();
    }
}
</script>
<style lang="less" scoped>
@import "../assets/css/base.less";
.business{
    .blk{
        div{
            position: relative;
        }
    }
    .title-name{
        font-size:36px;
        color: #ffffff;
        position:absolute;
        left: 30px;
        top:50px;
    }
    .mess{
        position: absolute;
        color: #ffffff;
        font-size: 16px;
        left: 30px;
        line-height: 26px;
        top:130px;
        padding-right:30px;
    }
}
</style>


